import { defineMessages } from 'react-intl';

export const messages: {
	errorFlagDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorFlagTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	errorFlagTitle: {
		id: 'company-hub.company-hub-common.link.cards.image.upload.error.flag.title',
		description: 'Title within the error flag that appears if some upload image error occurred.',
		defaultMessage: 'We can’t upload your image',
	},
	errorFlagDescription: {
		id: 'company-hub.company-hub-common.link.cards.image.upload.error.flag.description',
		description:
			'Description within the error flag that appears if some upload image error occurred.',
		defaultMessage: 'Refresh the page and try again.',
	},
});
